module.exports = __webpack_public_path__ + "static/media/koya.dc0dd507.svg";